<template>
  <div class="instructions">
    <p>
      חשוב להזין את <span class="bold">פרטי ההתחברות הקבועים שלך</span>. אם אין לך כאלו, צריך ליצור אותם בשני שלבים:
    </p>
    <p class="step">
    <strong>1.</strong> לקבל קוד מזהה אינטרנט <strong>
      <span class="link" @click="openLink('https://cal4u.cal-online.co.il/digitalwallet/#!/digital/internetId', 'cal1')">כאן</span>
    </strong>.
    </p>
    <p class="step">
    <strong>2.</strong>
    <strong><span class="link"
                  @click="openLink('https://services.cal-online.co.il/Card-Holders/SCREENS/AccountManagement/Joining.aspx', 'cal2')">להרשם באתר</span>
    </strong>
    ולבחור שם משתמש וסיסמה.
    </p>
  </div>
</template>

<script>

import Segment from '../../../../Segment';

export default {
  name: 'CalInstructions',
  methods: {
    openLink(url, source) {
      Segment.trackUserInteraction('CardInstructionsClicked', {
        source,
      });
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  p {
    margin: 0;
    .bold {
      font-weight: bold;
    }
    .link {
      text-decoration: underline;
      color: $riseup_blue;
      cursor: pointer;
      font-weight: bold;
    }
    &.step {
      margin: 10px 0 0;
    }
  }
</style>
